import { render, staticRenderFns } from "./ApproversList.vue?vue&type=template&id=31a81fba&"
import script from "./ApproversList.vue?vue&type=script&lang=js&"
export * from "./ApproversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports